import { render, staticRenderFns } from "./CompleteTaxForm.vue?vue&type=template&id=8005546e&scoped=true"
import script from "./CompleteTaxForm.vue?vue&type=script&lang=ts"
export * from "./CompleteTaxForm.vue?vue&type=script&lang=ts"
import style0 from "./CompleteTaxForm.vue?vue&type=style&index=0&id=8005546e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8005546e",
  null
  
)

export default component.exports